import { getBrowserLanguage } from 'documents-lib/js/utils/getBrowserLanguage';
import { isChirpEnabled } from 'documents-lib/js/utils/isChirpEnabled';
export const needsToLoadLocale = consentObject => {
  const legalConsentEnabled = isChirpEnabled() ? consentObject.documentLegalConsentEnabled : consentObject.deckLegalConsentEnabled;
  return !getBrowserLanguage() && legalConsentEnabled;
};